var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_5222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_5222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 87.5C54.3056 87.5 47.0139 85.1736 40.625 80.5208C34.2361 75.8681 29.7222 69.8611 27.0833 62.5H12.5V54.1667H25.2083C25 52.5 24.9132 50.9549 24.9479 49.5312C24.9826 48.1076 25.0694 46.875 25.2083 45.8333H12.5V37.5H27.0833C29.7222 30.1389 34.2361 24.1319 40.625 19.4792C47.0139 14.8264 54.3056 12.5 62.5 12.5C67.2917 12.5 71.8229 13.3507 76.0937 15.0521C80.3646 16.7535 84.1667 19.0972 87.5 22.0833L81.5625 27.9167C78.9931 25.6944 76.0938 23.9583 72.8646 22.7083C69.6354 21.4583 66.1806 20.8333 62.5 20.8333C56.5972 20.8333 51.3194 22.3785 46.6667 25.4687C42.0139 28.559 38.5069 32.5694 36.1458 37.5H62.5V45.8333H33.6458C33.3681 47.7083 33.2639 49.3576 33.3333 50.7812C33.4028 52.2049 33.5069 53.3333 33.6458 54.1667H62.5V62.5H36.1458C38.5069 67.4306 42.0139 71.441 46.6667 74.5312C51.3194 77.6215 56.5972 79.1667 62.5 79.1667C66.1806 79.1667 69.6354 78.5417 72.8646 77.2917C76.0938 76.0417 78.9931 74.3056 81.5625 72.0833L87.5 77.9167C84.1667 80.9028 80.3646 83.2465 76.0937 84.9479C71.8229 86.6493 67.2917 87.5 62.5 87.5Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFine);
export default __webpack_public_path__ + "static/media/Fine.013c657b4a913b110b40a1567bfca633.svg";
export { ForwardRef as ReactComponent };